import React, { Component } from 'react';
import { Col } from 'react-bootstrap';

import Combobox from '../Combobox';

/**
* Class ComboFilter
* Generic component to generate combo filters
**/
class ComboFilter extends Component {
  /**
  * props
  * title : title of the field
  * name : reference name prefix
  * parentFilter : parent filter reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
  * render
  * Rendering component function : display the combo filter
  **/
  render() {
    // Form rendering
    let cbxProps = {
      ref: "combobox",
      onChange: this.handleValueChange.bind(this),
      default: this.state.currentValue,
      id: this.props.name,
      placeholder: this.props.title
    };

    if(this.props.url) cbxProps.url = this.props.url;
    if(this.props.dataSource) cbxProps.dataSource = this.props.dataSource;
    if(this.props.optionValueKey) cbxProps.optionValueKey = this.props.optionValueKey;
    if(this.props.optionLabelKey) cbxProps.optionLabelKey = this.props.optionLabelKey;
    if(this.props.searchable) cbxProps.searchable = this.props.searchable;
    //if (cbxProps.searchable===undefined) cbxProps.searchable=true;
    if(this.props.multi) {
      cbxProps.multiple = this.props.multi;
      cbxProps.tags = this.props.multi;
    }

    let sm = 2;
    if(this.props.multi) sm = 4;
    if(this.props.size) sm = this.props.size;


    return(
      <Col componentClass="filterDateCombo" sm={sm}>
        <Combobox {...cbxProps} />
      </Col>
    );
  }

  /**
  * handleValueChange
  * Call the handleValueChange of the parent
  **/
  handleValueChange(obj) {
    let value;
    const idField = (this.props.optionValueKey) ? this.props.optionValueKey : "id";
    if(obj !== undefined) {
      if(this.props.multi && Array.isArray(obj)) {
        value = obj.map(item => (item[idField]) ? item[idField].toString() : null);
      } else {
        const id = obj[idField];
        value = id ? id.toString() : null;
      }
    }

    this.setState({currentValue : value});

    console.log(this.props.isObject);
    if(this.props.isArray === true) this.props.parentFilter.handleArrayChange(this, value);
    else if(this.props.isObject === true)  this.props.parentFilter.handleObjectChange(this, value, idField);
    else this.props.parentFilter.handleChange(this, value);
  }

  /**
  * reset
  * Reset the value
  **/
  reset() {
    this.handleValueChange();
    this.refs.combobox.clear();
  }

}

export default ComboFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/ComboFilter.js